import { Action } from '@ngrx/store';
import { type } from '../util';
import { Seatmap } from '@ibe.models/seatmap.model.lib';


export const ActionTypes = {
	LOADING: type('[Seatmap] loading '),
	PUT_SEATMAP: type('[Seatmap] put'),
	RESET: type('[Seatmap] reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload: {equipment: string, hours: number}) { }
}

export class LoadAircraftJSONAction implements Action {
  type = ActionTypes.LOADING;

  /**
   *Creates an instance of LoadAircraftJSONAction.
   * @param {aircraftFile} [payload]
   * @memberof LoadAircraftJSONAction
   */
  constructor(public payload: {aircraftFile: string}) { }
}

export class PutSeatmapAction implements Action {
	type = ActionTypes.PUT_SEATMAP;

	/**
	 *Creates an instance of PutSeatmapAction.
	 * @param {Seatmap} payload
	 * @memberof PutCountryCodesAction
	 */
	constructor(public payload: Seatmap) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutSeatmapAction | ResetAction;
